export default {
  env: 'production',
  assetsEndpoint: 'https://static.mdirector.com/assets/',
  storage: {
    domain: 'https://app.mdirector.com',
    file: '/storage.php',
  },
  services: {
    email_marketing: { frontUrl: 'https://app.mdirector.com' },
    email_transactional: { frontUrl: 'https://trans.mdirector.com' },
    marketing_automation: { frontUrl: 'https://automation.mdirector.com' },
    landing_optimizer: { frontUrl: 'https://landings.mdirector.com' },
    payments: { frontUrl: 'https://payments.mdirector.com' },
    integrations: {
      frontUrl: 'https://signup.mdirector.com',
      zapier: true,
      shopify: true,
      apis: true,
    },
  },
};
